import { Asset } from "./Asset";
import { Engine } from "@spi/Engine/Engine";

export class HttpBinaryAsset extends Asset {

    constructor(private uri: string, private callback: (engine: Engine, buffer: ArrayBuffer) => void) {
        super();
    }

    resolveAsset(engine: Engine): Promise<void> {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', this.uri, true);
            xhr.responseType = 'arraybuffer';

            xhr.onload = (e) => {
                if (xhr.status === 200) {
                    this.callback(engine, xhr.response);
                    resolve();
                } else {
                    reject(new Error(`${this.uri} returned status code ${xhr.status}`));
                }
            };

            xhr.send();
        });
    }

}
